<template>
  <div>
    <p class="book-export__info">
      Full subscribers get {{ maxLimit }} new downloads every 7 days.
    </p>
    <p class="book-export__additional-info">
      You currently have <strong>0 downloads </strong> remaining.
    </p>

    <p class="book-export__info">
      New downloads will be available in
      <strong> {{ textTime }} </strong>.
    </p>
    <img
      class="book-export__download-image"
      alt="Download limit reached"
      src="@/assets.app/images/books-download-limited.svg"
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'

import { secondsToTextDate } from '@/helpers/time'

const props = defineProps<{
  seconds: number
  maxLimit: number
}>()

const textTime = ref('')
const recallTimer = ref(true)
const secondsLeft = ref(0)

onBeforeMount(() => {
  secondsLeft.value = props.seconds
  updateTextTime()
})

/**
 * Reformat seconds to a "days, hours, minutes, seconds" string.
 * Recalls itself if secondsLeft more or equal to 0
 */
function updateTextTime(): void {
  if (secondsLeft.value <= 0) {
    // Reload the page to display the download link.
    setTimeout(() => {
      window.location.reload()
    }, 500)
    return
  }
  // Reformat seconds to a string.
  textTime.value = secondsToTextDate(secondsLeft.value)
  // Update secondsLeft (1 second less)
  secondsLeft.value--
  // If secondsLeft is more or equal to 0, call function 1 more time with 1 second timeout
  if (recallTimer.value && secondsLeft.value >= 0) {
    setTimeout(() => {
      updateTextTime()
    }, 1000)
    return
  }
  return
}

onBeforeUnmount(() => {
  // Stop timer when component is closed
  secondsLeft.value = 0
  recallTimer.value = false
})
</script>
